import { gql } from "graphql-request";

export const CREATE_PLAYBOOK = gql`
  mutation CreatePlaybook($input: CreatePlaybookInput!) {
    createPlaybook(input: $input) {
      id
      tenantId
      name
      objective
      description
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PLAYBOOK = gql`
  mutation UpdatePlaybook($input: UpdatePlaybookInput!) {
    updatePlaybook(input: $input) {
      id
      tenantId
      name
      objective
      description
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_PLAYBOOK = gql`
  mutation DeletePlaybook($id: ID!) {
    deletePlaybook(id: $id)
  }
`;

export const ADD_PLAYBOOK_ITEM = gql`
  mutation AddPlaybookItem($input: AddPlaybookItemInput!) {
    addPlaybookItem(input: $input) {
      id
      playbookId
      sopId
      sequence
      entryCriteria
      exitCriteria
      createdAt
      updatedAt
    }
  }
`;

export const REMOVE_PLAYBOOK_ITEM = gql`
  mutation RemovePlaybookItem($input: RemovePlaybookItemInput!) {
    removePlaybookItem(input: $input)
  }
`;

export const ADD_PLAYBOOK_TRANSITION = gql`
  mutation AddPlaybookTransition($input: AddPlaybookTransitionInput!) {
    addPlaybookTransition(input: $input) {
      id
      playbookId
      fromPlaybookItemId
      toPlaybookItemId
      outcomeKey
      label
      isDefault
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PLAYBOOK_ITEM = gql`
  mutation UpdatePlaybookItem($input: UpdatePlaybookItemInput!) {
    updatePlaybookItem(input: $input) {
      id
      positionX
      positionY
    }
  }
`;

export const REMOVE_PLAYBOOK_TRANSITION = gql`
  mutation RemovePlaybookTransition($input: RemovePlaybookTransitionInput!) {
    removePlaybookTransition(input: $input)
  }
`;